import { memo } from 'react';
import { Tooltip as TooltipAnt, TooltipProps } from 'antd';

const Tooltip: React.FC<TooltipProps> = ({ ...props }) => {
  return <TooltipAnt {...props} />;
};

export default memo(Tooltip);
